import useSWR from 'swr';

const fetchVerification = async (url) => {
    const rsp = await fetch(url);

     if (!rsp.ok) {
        const error = new Error("Request failed");
        error.status = rsp.status;
        error.info = await rsp.text().catch(() => null);
        throw error;
        }
    if (rsp.ok) {
        return rsp.json();
        }

    }

const useVerification = (user, repo, date) => {
    const shouldRetryOnError =(error) =>{
        return error.status != 403;
        }

    return useSWR(`/api/verify/${user}/${repo}/${date}`, fetchVerification, {shouldRetryOnError});
    }

export default useVerification;